import React, { useEffect, useState } from 'react';
import locationApis from '../../../../apis/location.api';
import stringUtils from '../../../../utils/string.utils';
import { Select } from 'antd';

const { Option } = Select;

const LocationSelect = ({
    label,
    parentId,
    defaultValue,
    onChange,
    onItemChange,
    disabled,
    isRequired,
    placeHolder,
}) => {
    const [list, setList] = useState([]);
    const [selectId, setSelectId] = useState('');

    const doReset = () => {
        setList([]);
        setSelectId('');

        if (onChange) {
            onChange('');
        }
    };

    const fetchData = async () => {
        if (!parentId) {
            doReset();
            return;
        }

        const { status, data } = await locationApis.getByParent(parentId);
        if (status !== 200) {
            doReset();
            return;
        }

        let listLocation = _.orderBy(data.data, ['l_sortorder'], ['asc']);
        // if (isRequired) {
        //     listLocation = [
        //         {
        //             l_id: '-1',
        //             l_name: placeHolder,
        //         },
        //         ...listLocation,
        //     ];
        // }
        // let _id = '';
        // if (listLocation.length > 0) {
        //     _id = listLocation[0].l_id;
        // }

        setList(listLocation);

        // setSelectId(_id);
        if (onChange) {
            onChange('');
        }
    };

    useEffect(
        () => () => {
            doReset();
        },
        []
    );

    useEffect(() => {
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentId]);

    // useEffect(() => {
    //     if (defaultValue) {
    //         setSelectId(defaultValue);
    //         if (onItemChange) {
    //             onItemChange(list.find((o) => o.l_id === defaultValue));
    //         }
    //     }
    // }, [defaultValue]);

    const onSearch = (input, option) => {
        if (option) {
            return (
                stringUtils
                    .nonAccentVietnamese(option.children.replace(/\s/g, ''))
                    .toLowerCase()
                    .indexOf(
                        stringUtils
                            .nonAccentVietnamese(input.replace(/\s/g, ''))
                            .toLowerCase()
                    ) >= 0
            );
        }
        return false;
    };

    const handleChange = (id) => {
        setSelectId(id);
        if (onChange) {
            onChange(id);
        }
        if (onItemChange) {
            onItemChange(list.find((o) => o.l_id === id));
        }
    };

    const showOptionItem = () => {
        let xhtml = null;
        if (list.length > 0) {
            xhtml = list.map((item) => (
                <Option value={item.l_id} key={item.l_id}>
                    {item.l_name}
                </Option>
            ));
        }
        return xhtml;
    };

    return (
        <>
            {label ? (
                <>
                    <label htmlFor="inputcountry" className="control-label">
                        {label}
                        {isRequired ? <span className="color"> * </span> : null}
                    </label>

                    <div className="clearfix mb20" />
                </>
            ) : null}
            <Select
                placeholder={placeHolder}
                value={selectId || undefined}
                onChange={(id) => handleChange(id)}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => onSearch(input, option)}
                disabled={disabled}
            >
                {showOptionItem()}
            </Select>
        </>
    );
};

LocationSelect.propTypes = {};

export default LocationSelect;
